var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNews1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.187 21H4.90543C3.85309 21 3 20.1046 3 19V5C3 3.89543 3.85309 3 4.90543 3H13.9083C15.1711 3 16.1948 4.07452 16.1948 5.4V18.4934C16.1948 19.8189 16.9242 21 18.187 21ZM18.187 21H20.0946C21.1469 21 22 20.1046 22 19V18.6C22 17.4954 21.1469 16.6 20.0946 16.6H18.9114M15.6105 3.8H16.5759C17.6282 3.8 18.4813 4.69543 18.4813 5.8V18.6C18.4813 19.8059 19.3287 20.8041 20.4326 20.9744M6.42978 14.5H12.765M6.42978 17.3H10.4785M6.42978 10.5V6.5L10.4785 10.5V6.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews1);
export default __webpack_public_path__ + "static/media/news_1.74370386da8aa8e574bb4ea192c28e86.svg";
export { ForwardRef as ReactComponent };